import React, { useContext, useEffect, useState } from 'react';
import { Drawer, Spin, Button } from 'antd';
import { DrawerContext } from '@CONTEXTS';
import { Tabs } from 'antd';
const { TabPane } = Tabs;

const HJDrawer = ({
  tabs,
  activeTabKey,
  tabBarExtraContent,
  onSave,
  hideFooter,
}) => {
  const { visible, title, loading, width, values, setClose } =
    useContext(DrawerContext);
  const [activeKey, setActiveKey] = useState('0');

  useEffect(() => {
    setActiveKey(activeTabKey || '0');
  }, [activeTabKey, visible]);

  const TabChilds = () => {
    return tabs.map((item, index) => (
      <TabPane
        tab={item.title}
        key={item.key || String(index)}
        disabled={item.disabled}
      >
        {item.component}
      </TabPane>
    ));
  };

  return (
    <Drawer
      title={title}
      placement="right"
      width={width}
      onClose={() => setClose()}
      visible={visible}
      destroyOnClose
      footer={
        !hideFooter && (
          <div
            style={{
              textAlign: 'right',
            }}
          >
            <Button
              onClick={() => setClose()}
              style={{ marginRight: 8 }}
              disabled={loading}
            >
              Kapat
            </Button>
            {typeof onSave === 'function' && (
              <Button
                type="primary"
                onClick={() => onSave(values)}
                disabled={loading}
              >
                Kaydet
              </Button>
            )}
          </div>
        )
      }
    >
      <Spin spinning={loading}>
        {tabs.length > 0 && (
          <Tabs
            activeKey={activeKey}
            defaultActiveKey={'0'}
            onChange={(e) => setActiveKey(e)}
            type="card"
            size="small"
            tabBarExtraContent={tabBarExtraContent}
          >
            {TabChilds()}
          </Tabs>
        )}
      </Spin>
    </Drawer>
  );
};

export default HJDrawer;
